import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-arch-dark dark:bg-black text-arch-light dark:text-gray-400 py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvcG5n/6e794689a22df1922a5088f411fb4372.png"
                alt="WALL | WELL Logo"
                className="h-10 w-auto dark:invert"
              />
            </Link>
            <p className="text-arch-gray dark:text-gray-500 text-sm leading-relaxed mb-6">
              Inovativní WPC panely pro moderní architektonické a designové projekty. Zastoupení pro ČR.
            </p>
          </div>

          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-arch-gray dark:text-gray-600 uppercase tracking-widest mb-6">Navigace</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/features" className="hover:text-accent-teal transition-colors">Vlastnosti</Link></li>
              <li><Link to="/products" className="hover:text-accent-sage transition-colors">Produkty a řady</Link></li>
              <li><Link to="/materials" className="hover:text-brand-500 transition-colors">Vzorník materiálů</Link></li>
              <li><Link to="/specifications" className="hover:text-accent-clay transition-colors">Katalogová data</Link></li>
              <li><Link to="/downloads" className="hover:text-brand-500 transition-colors text-brand-500">Ke stažení</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-arch-gray dark:text-gray-600 uppercase tracking-widest mb-6">Základní data</h4>
            <ul className="space-y-4 text-sm font-mono text-arch-gray dark:text-gray-500">
              <li>Formát: 1100 × 2800 mm</li>
              <li>Tloušťky: 5,8,12 mm</li>
              <li>Třída hořlavosti: B1</li>
              <li>Emisní třída: E0</li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="text-xs font-bold text-arch-gray dark:text-gray-600 uppercase tracking-widest mb-6">Kontakt</h4>
            <div className="space-y-2 text-sm text-arch-light dark:text-gray-400">
              <a href="mailto:info@wallwell.cz" className="block hover:text-brand-500 transition-colors">info@wallwell.cz</a>
              <div className="font-mono">+420 777 016 374</div>
            </div>
          </div>
        </div>

        <div className="border-t border-arch-gray/20 dark:border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs font-mono text-arch-gray dark:text-gray-600">
          <div>&copy;{new Date().getFullYear()} WALL | WELL. Všechna práva vyhrazena.</div>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <span className="text-accent-sage">BAMBOO CORE Tech.</span>
            <span className="text-accent-teal">CLASS B1</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;